import { render, staticRenderFns } from "./AuthoriseRecipient.vue?vue&type=template&id=6f52b0e9&"
import script from "./AuthoriseRecipient.vue?vue&type=script&lang=js&"
export * from "./AuthoriseRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports